import { styled } from '@mui/material/styles'
import { CardHeader } from '@mui/material'
import ThemeConfig from './../../theme/ThemeConfig'

const PREFIX = 'CommonCardHeader'

const classes = {
  cardHeader: `${PREFIX}-cardHeader`,
  logo: `${PREFIX}-logo`,
  img: `${PREFIX}-img`,
}

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.cardHeader}`]: {
    display: 'inline-block',
    verticalAlign: 'center',
    fontSize: '1rem',
    fontWeight: 'bold',
  },

  [`& .${classes.logo}`]: {
    height: 50,
    display: 'inline-block',
    width: 55,
    backgroundColor: ThemeConfig.palette.background.appBar,
    verticalAlign: 'middle',
  },

  [`& .${classes.img}`]: {
    maxWidth: '100%',
  },
}))

const getChipOrEllipsisMenuButton = props => {
  return props.chip ? props.chip : props.ellipsisMenuButton
}

const showCardMedia = (props, classes) => {
  return <img src={props.image} className={classes.logo} alt="Apexlogo" />
}

const CommonCardHeader = props => {
  const cardLogo = props.image
    ? showCardMedia(props, classes)
    : getChipOrEllipsisMenuButton(props)

  const headerStyles = props.headerStyles
    ? props.headerStyles
    : classes.cardHeader

  return (
    <Root>
      <CardHeader
        title={props.title}
        classes={{ title: headerStyles }}
        action={cardLogo}
      />
    </Root>
  )
}

export default CommonCardHeader
